jQuery(document).ready(function() {
    init_tabs();
});
jQuery(document).ajaxComplete(function($) {
    setTimeout(function() {
        init_tabs();
    }, 500);
});
function init_tabs() {
    const $ = jQuery.noConflict();

    $('.tabs-wrapper:not(.init)').each(function() {
        const wrapper = $(this);
        wrapper.addClass('init');

        wrapper.find('.tab').click(function() {
            const wrapper = $(this).parents('.tabs-wrapper');
            const tab = $(this);

            wrapper.attr('data-active-tab', (tab.index() + 1));

            wrapper.find('.tab-content:nth-child(' + (tab.index() + 1) + ')').trigger('showTab');

            return false;
        });

        if (!wrapper.is('[data-active-tab]')) {
            wrapper.attr('data-active-tab', 1);
        }
    });
}
